import { useBridge } from '../../../application/hooks/useBridge';
import { DefaultBox } from '../../etc/LBox/LBox';
import { useRecoilState } from 'recoil';
import * as Atom from '../../../application/recoil';

const TestSkt = () => {
  const br: any = useBridge();

  const moveExternalWebBrowser2 = () => {
    console.log('openExternalBrowser');
    br.openExternalBrowser({ url: '//naver.com' });
  };

  const moveExternalWebBrowser = () => {
    console.log('openExternalBrowser');
    br.openExternalBrowser({ url: 'https://naver.com' });
  };
  const moveInternalWebBrowser = () => {
    console.log('openInternalBrowser');
    br.openNativeWebView({
      url: 'https://naver.com',
      title: '대출 비교/테스트',
      closeType: 'B',
    });
  };
  const closeScreen = () => {
    console.log('close');
    br.close();
  };
  const movePassMain = () => {
    console.log('goNativeMain');
    br.goNativeMain();
  };
  const moveEbmp = () => {
    console.log('goNativeTab');
    br.goNativeTab({
      tabCode: 'TAB02',
      url:
        process.env.REACT_APP_EBMP_SKT_URI +
        '?extraParam=3&extraParam2=A007BA01',
    });
  };

  const [personal] = useRecoilState(Atom.personalInfo);
  const [userInfo] = useRecoilState(Atom.userInfo);

  return (
    <DefaultBox>
      <h1>bridge interface SKT</h1>
      <p>srcCd : {userInfo.srcCd}</p>
      <p>custSeq : {personal.custSeq}</p>
      <p>env : {process.env.REACT_APP_ENV}</p>
      <p style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
        query : <br />
        {window.location.search}
      </p>
      <p>app version : {userInfo.version}</p>
      <br />
      <div>
        <button onClick={moveExternalWebBrowser2}>
          // 외부 브라우저로 이동
        </button>
      </div>
      <div>
        <button onClick={moveExternalWebBrowser}>외부 브라우저로 이동</button>
      </div>
      <div>
        <button onClick={moveInternalWebBrowser}>내부 브라우저로 이동</button>
      </div>
      <div>
        <button onClick={closeScreen}>화면 종료</button>
      </div>
      <div>
        {/*fixme*/}
        <button onClick={movePassMain}>PASS 메인화면 홈 탭으로 이동</button>
      </div>
      <div>
        <button onClick={moveEbmp}>금융 상품으로 이동</button>
      </div>
    </DefaultBox>
  );
};

export default TestSkt;
